import { httpClient } from "@/utils/httpClient";
import type { AuditLog } from "@/lib/gdpr";
import type { DRFPaginatedResponse } from "@/types";

interface BackendAuditLog {
    id?: string | number;
    timestamp?: string;
    created_at?: string;
    user_name?: string;
    userName?: string;
    username?: string;
    user_id?: string | number;
    userId?: string | number;
    action?: string;
    resource?: string;
    resource_id?: string | number;
    resourceId?: string | number;
    details?: Record<string, unknown>;
    ip_address?: string;
    ipAddress?: string;
    success?: boolean;
}

const ENDPOINT_CANDIDATES = ["/audit-logs/", "/audit/logs/"];

const mapBackendAuditLog = (item: BackendAuditLog): AuditLog => ({
    id: String(item.id ?? crypto.randomUUID()),
    timestamp: item.timestamp ?? item.created_at ?? new Date().toISOString(),
    userId: String(item.userId ?? item.user_id ?? ""),
    userName: item.userName ?? item.user_name ?? item.username ?? "Sistema",
    action: item.action ?? "VIEW",
    resource: item.resource ?? "system",
    resourceId: String(item.resourceId ?? item.resource_id ?? ""),
    details: item.details,
    ipAddress: item.ipAddress ?? item.ip_address ?? "-",
    success: item.success ?? true,
});

export const auditLogsService = {
    async list(pageSize = 100): Promise<AuditLog[]> {
        const errors: unknown[] = [];

        for (const endpoint of ENDPOINT_CANDIDATES) {
            try {
                const response = await httpClient.get<
                    DRFPaginatedResponse<BackendAuditLog> | BackendAuditLog[]
                >(`${endpoint}?page=1&page_size=${pageSize}`);

                const items = Array.isArray(response) ? response : response.results;
                return items.map(mapBackendAuditLog);
            } catch (error) {
                errors.push(error);
            }
        }

        throw errors[0] ?? new Error("Unable to load audit logs");
    },
};

export default auditLogsService;
